module.exports = __webpack_public_path__ + "media/src/images/icons/minus-signs-53ad9bac28b7ae0887116e54794ff0e8.jpg";